/**
 * Internal dependencies
 */
import { createRegistry } from './registry';
export default createRegistry();
//# sourceMappingURL=default-registry.js.map